var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPadlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.59265 11.024C2.72614 9.17698 4.17813 7.74297 6.02625 7.62549C7.13148 7.55524 8.48288 7.5 10 7.5C11.5171 7.5 12.8685 7.55524 13.9737 7.62549C15.8219 7.74297 17.2739 9.17698 17.4074 11.024C17.4612 11.7695 17.5 12.5708 17.5 13.3333C17.5 14.0959 17.4612 14.8972 17.4074 15.6427C17.2739 17.4897 15.8219 18.9237 13.9737 19.0412C12.8685 19.1114 11.5171 19.1667 10 19.1667C8.48288 19.1667 7.13148 19.1114 6.02625 19.0412C4.17813 18.9237 2.72614 17.4897 2.59265 15.6427C2.53876 14.8972 2.5 14.0959 2.5 13.3333C2.5 12.5708 2.53876 11.7695 2.59265 11.024ZM11.6667 12.5C11.6667 13.1169 11.3315 13.6555 10.8333 13.9437V15C10.8333 15.4602 10.4602 15.8333 10 15.8333C9.53976 15.8333 9.16667 15.4602 9.16667 15V13.9437C8.6685 13.6555 8.33333 13.1169 8.33333 12.5C8.33333 11.5795 9.07953 10.8333 10 10.8333C10.9205 10.8333 11.6667 11.5795 11.6667 12.5Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.8335 5.00004C5.8335 2.69885 7.69898 0.833374 10.0002 0.833374C12.3013 0.833374 14.1668 2.69885 14.1668 5.00004V8.33337C14.1668 8.79361 13.7937 9.16671 13.3335 9.16671C12.8733 9.16671 12.5002 8.79361 12.5002 8.33337V5.00004C12.5002 3.61933 11.3809 2.50004 10.0002 2.50004C8.61945 2.50004 7.50016 3.61933 7.50016 5.00004V8.33337C7.50016 8.79361 7.12707 9.16671 6.66683 9.16671C6.20659 9.16671 5.8335 8.79361 5.8335 8.33337V5.00004Z",
    fill: "#777E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.e0aa35e26a1de082b20774673f3753c0.svg";
export { ForwardRef as ReactComponent };